export function OscarRequestEventCtrl ($uibModalInstance, $scope, OscarEvents, messages, event) {
  $scope.event = event;

  $scope.OscarEvents = new OscarEvents();

  $scope.continue = function () {
    $scope.OscarEvents.getOscarItems($scope.event).then(data => {
      $uibModalInstance.close(data);
    }).catch(err => {
      messages.error(err);
    });
  };

  $scope.overwrite = function () {
    $scope.OscarEvents.overwrite($scope.event).then(data => {
      $uibModalInstance.close(data);
    }).catch(err => {
      $uibModalInstance.dismiss();
    });
  };
}